/** How many resources the nearest loader still waits for, as React state. Zero outside a loader. */
import { useCallback, useSyncExternalStore } from 'react';
import { useResourceLoader } from './useResource.js';
export function usePendingResourceCount() {
    const loader = useResourceLoader();
    const subscribe = useCallback((listener) => (loader ? loader.subscribePending(listener) : () => { }), [loader]);
    return useSyncExternalStore(subscribe, () => loader?.pendingResourceCount ?? 0);
}
//# sourceMappingURL=usePendingResourceCount.js.map